import React from 'react';

const Footer = () => {
    return (
        <div style={{backgroundColor:'black',color:'white',textAlign:'center'}}>
            <h2>Powered by Mohammad Farhad</h2>
            <h3>All-Right@ 2023-2024 </h3>
        </div>
    );
};

export default Footer;